//@flow
import React, { PureComponent } from 'react';
import PaginatedTable from 'common/components/core/table/PaginatedTable';
import DefaultExpanderArrow from 'common/components/core/common/ExpanderArrow';

const paginatedTableWithExpanderFactory = ({
    ExpanderArrow = DefaultExpanderArrow
}) => {
    class PaginatedTableWithExpander extends PureComponent {
        renderExpander = props => {
            return <ExpanderArrow {...props} />;
        };
        render() {
            return (
                <PaginatedTable
                    {...this.props}
                    ExpanderComponent={this.renderExpander}
                />
            );
        }
    }
    return PaginatedTableWithExpander;
};

const PaginatedTableWithExpander = paginatedTableWithExpanderFactory({});
export { paginatedTableWithExpanderFactory, PaginatedTableWithExpander };
export default PaginatedTableWithExpander;
